import axios from 'axios';

let prefix = "/win-condition"

const WinConditionApi = {
	listWinCondition(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	getWinConditionInfo(payload) {
		return axios.get(prefix + "/get", { params: payload })
	},
	archiveWinCondition(payload) {
		return axios.delete(prefix + "/archive", { params: payload })
	},
	createWinCondition(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateWinCondition(payload) {
		return axios.post(prefix + "/update", payload)
	},
}

export default WinConditionApi;
